import template from './sw-cms-el-product-finder.html.twig';
import './sw-cms-el-product-finder.scss';

const { Component, Mixin } = Shopware;

Component.register('sw-cms-el-product-finder', {
    template,

    mixins: [
        Mixin.getByName('cms-element')
    ],

    computed: {
        productFinder() {
            return this.element.data?.productFinder;
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('product-finder');
        }
    }
});